import React from 'react';
import { connect } from 'react-redux';
import { mapState, mapDispatch } from './reducer.js';

class SearchContainer extends React.Component {
  render() {
    const {joinedTeams, results} = this.props.search;
    const {SearchForm, SearchResults} = this.props;
    return (
      <div>
        <h1 className="txt-center">Search</h1>
        <SearchForm
          initialTerm={this.props.initialTerm}
          initialTermType={this.props.initialTermType}
          loading={results.loading}
          sports={this.props.sports}
          onSearch={this.props.cmd.search}
          />

        <div className="col-xs-12 col-sm-offset-2 col-sm-8">
          <SearchResults
            termType={results.termType}
            joinedTeams={joinedTeams}
            items={results.items}
            loading={results.loading}
            hasNextPage={!!results.nextPageUrl}
            onNextPage={this.props.cmd.nextPage} />
        </div>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(SearchContainer);
